import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import type { Player } from '../player.type';
import type { Die } from '../die.type';
import { StatusEffectRegistry } from '../status-effects';

export class Dopey extends Modifier {
  static readonly baseTitle = 'Dopey';
  static readonly baseText = 'Decreases reroll count by 1. Stable.';
  static readonly baseIcon = 'brain';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Dopey.baseTitle;
  text = Dopey.baseText;
  icon = Dopey.baseIcon;
  tags: Array<ModifierTags> = [...Dopey.baseTags];
  priority = Dopey.basePriority;

  update(stacks: number, params?: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: Array<Die>;
    rerollMax: number;
    activePlayer: Player;
    inactivePlayer: Player;
  }) {
    rerollMax -= 1; // Always reduce rerolls by 1, stacks represent duration

    return { dice, rerollMax, activePlayer, inactivePlayer };
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Dopey, Dopey);
